var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-card",
    {
      staticClass: "bank-account-balance-card",
      attrs: {
        isCustomizable: _vm.settings.isCustomizable,
        loading: _vm.loading,
        placeholder: _vm.placeholder,
        placeholderImg: "/ressources/logged/img/dashboard/dashboard-bank.svg",
        type: _vm.settings.context
      },
      on: {
        "edit-card": _vm.toggleSettingsForm,
        "hide-card": function($event) {
          return _vm.$emit("hide-card", _vm.type)
        },
        "refresh-card": function($event) {
          return _vm.fetchCard(_vm.type, {}, true)
        }
      }
    },
    [
      _c("template", { slot: "title" }, [_vm._v(_vm._s(_vm.name))]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "actions" },
        [
          _c(
            "portal",
            { attrs: { to: "dashboardSettingsForm" } },
            [
              _vm.showSettingsForm
                ? _c("card-setting-overlay", {
                    attrs: {
                      formName: _vm.settingsFormName,
                      cardCustomSettings: _vm.customSettings,
                      cardName: _vm.type,
                      cardSettings: _vm.settings
                    },
                    on: {
                      fetched: _vm.fetchCard,
                      "close-form": _vm.toggleSettingsForm,
                      "custom-settings-saved": function($event) {
                        return _vm.fetchCard(_vm.type, {}, true)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "content" }, [
        _vm.cardData && _vm.cardData.length > 0
          ? _c(
              "div",
              { staticClass: "ov-auto" },
              [
                _c("div", { staticClass: "acenter mt-2 mb-4" }, [
                  _c("p", { staticClass: "mb-2" }, [
                    _vm._v(
                      _vm._s(_vm.$l10n.__("Total de vos comptes bancaires"))
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "bold fs-6",
                      class: { red: _vm.totalBalance < 0 }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm._f("numberformat")(_vm.totalBalance(), true))
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.cardData,
                      "show-header": false,
                      "row-class-name": "no-hover",
                      stripe: ""
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "label", "class-name": "semibold lc-2" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "balance",
                        align: "right",
                        "class-name": "semibold"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  { class: { red: scope.row.balance < 0 } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm._f("numberformatWithOptions")(
                                            scope.row.balance,
                                            {
                                              currencysymbol:
                                                scope.row.currencySymbol
                                            },
                                            true
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1346014234
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }